import { CookiesDataProps, CookiesDataResponse } from 'types/overlays';

import { api } from './setupApi';

class CookiesDataModel {
  link = '/cookies';

  updateCookiesLink = '/bulk_update';

  getData = (): Promise<Array<CookiesDataProps>> => api.get(this.link).then(({ data }) => data);

  updateData = ([...data]: Array<CookiesDataProps>) =>
    api.put<CookiesDataResponse>(`${this.link}/${this.updateCookiesLink}`, { cookies: data }).then(({ data }) => data);
}

export const cookiesDataModel = new CookiesDataModel();
